module.exports = __webpack_public_path__ + "img/three-locks.69d7ffc.svg";